module.exports = __webpack_public_path__ + "img/logo-light-unica2.ba8db387.png";